import Vue from 'vue'
import Vuex from 'vuex'
import { IAppState } from './modules/app'
import { IUserState } from './modules/user'
import { ITagsViewState } from './modules/tags-view'
import { ISettingsState } from './modules/settings'
import { ILeftMenuState } from './modules/leftmenu'

Vue.use(Vuex)

export interface IRootState {
  app: IAppState
  user: IUserState
  tagsView:ITagsViewState
  settings: ISettingsState
  leftmenu: ILeftMenuState
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({})
